import { action as apiAction } from 'api/Api'
import { setContent } from '../redux/elements'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  noteId: number
  content: any
}

export default (payload: Payload) => async dispatch => {
  const { noteId, content } = payload

  const optimisticAction = optimisticDispatch(dispatch, setContent({
    elementId: noteId,
    content
  }))

  try {
    await apiAction('ChangeNoteContent', {
      id: noteId,
      rtText: content
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    if (error.code !== 401) {
      throw error
    }
  }
}
